import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import Detail from "./Detail/container";
import List from "./List/container";

import "./style.less";

export type MapProps = RootContainerProps & {
  hasForums: boolean;
  view: "list" | "detail";
};

export default (props: MapProps) => {
  const i18n = useI18n();

  return (
    <Container {...getContainerProps(props)} className="wsc_content_member_forum">
      {props.hasForums ? (
        props.view === "detail" ? (
          <Detail {...getRootContainerProps(props)} />
        ) : (
          <List {...getRootContainerProps(props)} />
        )
      ) : (
        <div>{i18n.infoNoForums}</div>
      )}
    </Container>
  );
};
